module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maskShow),
      expression: "maskShow"
    }],
    staticClass: "wx-mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "wx-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wx-tips-l"
  }, [_c('div', {
    staticClass: "wx-tips-l-item"
  }, [_c('img', {
    staticClass: "icon-wx icon-num",
    attrs: {
      "src": require("../assets/images/20181212/icon_one.png")
    }
  }), _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('click')))]), _c('img', {
    staticClass: "icon-wx icon-tip-item",
    attrs: {
      "src": require("../assets/images/20181212/select@3x.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('wx-tip1')))])]), _vm._v(" "), _c('div', {
    staticClass: "wx-tips-l-item"
  }, [_c('img', {
    staticClass: "icon-wx icon-num",
    attrs: {
      "src": require("../assets/images/20181212/icon_two.png")
    }
  }), _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('select')))]), _c('img', {
    staticClass: "icon-wx icon-tip-item",
    attrs: {
      "src": require("../assets/images/20181212/Browser@3x.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('wx-tip2')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-tips-r"
  }, [_c('img', {
    staticClass: "icon-wx-arrow",
    attrs: {
      "src": require("../assets/images/20181212/arrow@3x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12eb011d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WxMask.vue
// module id = 293
// module chunks = 1